import { nodeName } from 'jquery';
import './navi-bootstrap-offcanvas.scss';

$('#offcanvas-nav .menu-item-has-children>a').on('click', (e) => {
    e.preventDefault();
    const parent = $(e.target).parent();
    const subList = parent.find('ul.sub-menu');
    subList.slideToggle('slow')
})

$('#offcanvas-nav .menu-item-has-children  ul').css({
    display: 'none'
})